module.exports = __webpack_public_path__ + "static/media/egift-purchase-history-card-background-en.90af84aa.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/egift/egift-purchase-history-card-background-en.png
// module id = 1509
// module chunks = 37